var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { ArticleCardContent } from '@lux/article-card';
import { Spacer } from '@lux/tokens';
import { Text } from '@lux/text';
export var TextEllipsis = styled(Text)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n"], ["\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n"])));
export var StyledArticleCardContent = styled(ArticleCardContent)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding: ", " ", ";\n"], ["\n    padding: ", " ", ";\n"])), Spacer.S, Spacer.XS);
var templateObject_1, templateObject_2;
